export function HomePage() {
  return (
    <section>
      <h1>Welcome to CRM</h1>
      <p>Select an object from the sidebar after schema and permissions are available.</p>
    </section>
  )
}
